import React from 'react';

const SIZE_CLASSES = {
  sm: 'w-8 h-[2px]',
  md: 'w-10 h-[3px]'
};

export default function ColombiaFlagAccent({ size = 'sm', className = '' }) {
  const barClass = SIZE_CLASSES[size] ?? SIZE_CLASSES.sm;

  return (
    <div className={`flex justify-center gap-1.5 ${className}`}>
      <span className={`${barClass} bg-amber-300 rounded-full`} />
      <span className={`${barClass} bg-blue-400 rounded-full`} />
      <span className={`${barClass} bg-red-400 rounded-full`} />
    </div>
  );
}
